import React, { useEffect, useRef } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowLeftIcon, CheckIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import type { FormVariant } from '../../types/form';
type FormSuccessProps = {
  success: FormVariant['success'];
};
export function FormSuccess({
  success
}: FormSuccessProps) {
  const reduceMotion = useReducedMotion();
  const headingRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    headingRef.current?.focus();
  }, []);
  return <motion.div initial={reduceMotion ? {
    opacity: 0
  } : {
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.25,
    ease: [0.23, 1, 0.32, 1]
  }} className="py-6 text-center sm:py-10" role="status" data-id="element-482" data-mp="q1flyctqlgav">
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#E9F6EC]" data-id="element-483" data-mp="2fgwvcnbhi9du">
        <CheckIcon className="h-7 w-7 text-[#1B7A3D]" strokeWidth={2.5} aria-hidden="true" data-id="element-484" data-mp="2aibvip059rpx" />
      </span>
      <h2 ref={headingRef} tabIndex={-1} className="display mt-6 text-[28px] font-semibold text-ink outline-none sm:text-[32px]" data-id="element-485" data-mp="cgygrnit1be">
        {success.headline}
      </h2>
      <p className="mx-auto mt-3 max-w-[380px] text-[16px] leading-[1.55] text-ink-muted" data-id="element-486" data-mp="3mkq91hsrz0h8">{success.body}</p>

      {success.steps && <div className="mx-auto mt-8 max-w-[400px] border-t border-canvas-line pt-6 text-left" data-id="element-487" data-mp="3rjtgf8w89isd">
          <p className="text-[14px] font-semibold text-ink" data-id="element-488" data-mp="j4t0tee6c2lj">What happens next</p>
          <ol className="mt-4 space-y-3" data-id="element-489" data-mp="o1jclpiy4c15">
            {success.steps.map((step, index) => <li key={step} className="flex items-start gap-3 text-[14px] leading-[1.5] text-ink-soft" data-id="element-490" data-mp="9egf3iumi3dt" data-mpi={index}>
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-soft text-[12px] font-semibold text-brand" data-id="element-491" data-mp="ebq1sqqmo0xy">
                  {index + 1}
                </span>
                <span className="pt-0.5" data-id="element-492" data-mp="16u40esjsfqy3">{step}</span>
              </li>)}
          </ol>
        </div>}

      {success.primary && <a href={success.primary.href} className="mt-8 inline-flex h-12 w-full items-center justify-center rounded-[7px] bg-brand px-6 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-hover sm:w-auto" data-id="element-493" data-mp="1gmop201nlby4">
          {success.primary.label}
        </a>}

      <div className={success.primary ? 'mt-5' : 'mt-8'} data-id="element-494" data-mp="xqoz0us8kih6">
        <SmartLink href="/" className="inline-flex items-center gap-1.5 text-[15px] font-medium text-brand transition-colors duration-150 ease-out hover:text-brand-hover" data-id="element-495" data-mp="xs9seh2tdvdg">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-496" data-mp="ny11fxtfmahe" />
          Back to homepage
        </SmartLink>
      </div>
    </motion.div>;
}